import { HelpTip } from "@/components/HelpTip";

export const StatValue = ({ value, className = "", max, chars, testId }) => (
  <p className={`num stat-value ${className}`} style={{ "--chars": chars || String(value ?? "").length, ...(max ? { "--stat-max": max } : {}) }} data-testid={testId}>{value}</p>
);


export const PageHeader = ({ title, subtitle, help, helpTitle, actions, testId }) => (
  <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8 rise" data-testid={testId}>
    <div>
      <h1 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight flex items-center gap-3">
        {title}
        {help && <HelpTip title={helpTitle || title} testId={`${testId}-help`}>{help}</HelpTip>}
      </h1>
      {subtitle && <p className="text-muted-foreground mt-1 text-sm sm:text-base max-w-2xl">{subtitle}</p>}
    </div>
    {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
  </div>
);

export const KpiCard = ({ label, value, sub, icon: Icon, tone = "primary", testId, delay = 0, className = "", chars }) => {
  const tones = {
    primary: "bg-primary/15 text-primary", emerald: "bg-emerald-500/15 text-emerald-500",
    amber: "bg-amber-500/20 text-amber-400", rose: "bg-rose-500/15 text-rose-500", cyan: "bg-cyan-500/15 text-cyan-500",
  };
  return (
    <div data-testid={testId} className={`rise rise-${delay} card-hover relative overflow-hidden rounded-2xl border border-border bg-card p-5 sm:p-6 min-w-0 ${className}`}>
      {Icon && <div className={`absolute top-4 right-4 w-10 h-10 rounded-xl flex items-center justify-center ${tones[tone]}`}><Icon className="w-5 h-5" /></div>}
      <div className={`stat-fluid ${Icon ? "pr-12" : ""}`}>
        <p className="text-xs uppercase tracking-widest text-muted-foreground font-medium">{label}</p>
        <StatValue value={value} className="font-bold mt-2" max="1.5rem" chars={chars} />
        {sub && <p className="text-xs text-muted-foreground mt-1">{sub}</p>}
      </div>
    </div>
  );
};

export const EmptyState = ({ icon: Icon, title, text, action, testId }) => (
  <div data-testid={testId} className="rounded-2xl border border-dashed border-border p-10 text-center bg-card/40">
    {Icon && <Icon className="w-10 h-10 mx-auto text-primary/70 mb-3" />}
    <h3 className="font-display text-lg font-semibold">{title}</h3>
    <p className="text-sm text-muted-foreground mt-1 max-w-md mx-auto">{text}</p>
    {action && <div className="mt-5">{action}</div>}
  </div>
);

export const Field = ({ label, children, help, className = "" }) => (
  <div className={`space-y-1.5 ${className}`}>
    <label className="text-sm font-medium flex items-center gap-2">{label}{help}</label>
    {children}
  </div>
);
